import { Info } from 'lucide-react';

/**
 * Provenance badge (PRO-0590, ADR-038 AC-7). When a KPI is not live
 * (`isLive:false` — every Increment-1 static tile), it renders the mandatory
 * "Illustrative — not live data" label so no viewer mistakes seed values for a
 * governed figure. When a KPI is live (future `FabricInsightsSource`) it renders
 * nothing — the absence of the badge is the "this is real" signal, and the label
 * disappears with no other UI change.
 */
export function ProvenanceBadge({ isLive }: { isLive: boolean }) {
  if (isLive) {
    return null;
  }
  return (
    <span className="inline-flex items-center gap-1 rounded-sm bg-warning-bg px-2 py-0.5 text-xs font-medium text-warning-foreground">
      <Info aria-hidden="true" className="h-3 w-3 shrink-0" />
      Illustrative — not live data
    </span>
  );
}
